import { gql } from '@moonpig/web-core-graphql'

export const GetDesignWithIntentsGQL = gql`
  query GetDesignWithIntents($productKey: String!, $intents: [DesignIntent!]!) {
    designDefault(productKey: $productKey, intents: $intents) {
      __typename
      ... on Design {
        scenes {
          availableCustomisations
          height
          id
          isCustomised
          title
          width
          customisations {
            template {
              imageCollage {
                elementId
                editedImage {
                  id
                  url
                }
              }
              imageDynamic {
                elementId
                textParts
              }
              imageUpload {
                editedImage {
                  id
                  url
                }
                elementId
                sourceImage {
                  id
                  transform {
                    position {
                      x
                      y
                    }
                    rotation
                    scale
                  }
                }
              }
              textPlaceholder {
                elementId
                textParts
              }
              textPlain {
                elementId
                substitutions
                text
              }
              textStyled {
                colorId
                elementId
                fontFaceId
                fontSize
                horizontalAlignment
                substitutions
                text
                verticalAlignment
              }
            }
          }
        }
      }
      ... on DesignTemplatesServiceError {
        message
      }
      ... on DesignServiceError {
        message
      }
      ... on Error {
        message
      }
    }
  }
`
